<template>
  <tile-card dark
    :icon="typeIcon"
    :iconColor="'white'"
    :title="titleLabel"
    :subtitle="typeLabel"
    :textOnMouseOver="titleLabel"
    titleStyle="font-size: 16px; font-weight: bold"
    :backgroundColor="'primary'"
    :borderRadius="'10px'"
    contentPadding="px-10"
    @click="$emit('didTapItem', content)"
  ></tile-card>
</template>

<script>
import TileCard from '@/components/TileCard.vue';

export default {
  components: { TileCard },
  props: { content: { type: Object }, index: { type: Number } },
  computed: {
    titleLabel() {
      let label = '';
      // label += this.index !== undefined ? `${this.content.index + 1} - ` : '';
      label += this.content.title;
      return label;
    },
    typeLabel() {
      if (this.content.type === 'pdf') {
        return 'Arquivo PDF';
      }
      if (this.content.type === 'folder') {
        return 'Pasta de arquivos';
      }
      if (this.content.type === 'images') {
        return 'Galeria de imagens';
      }
      return '';
    },
    typeIcon() {
      if (this.content.type === 'pdf') {
        return 'insert_drive_file';
      }
      if (this.content.type === 'folder') {
        return 'folder';
      }
      if (this.content.type === 'images') {
        return 'image';
      }
      return 'image';
    },
  },
};
</script>

<style>
</style>
